// extracted by mini-css-extract-plugin
module.exports = {"related_links":"RelatedLinks-module--related_links--1B5vW","type":"RelatedLinks-module--type--3PzBN","title":"RelatedLinks-module--title--cNq28"};